import React, { useState } from 'react'
import henceforthApi from '../utils/henceforthApi';
import Swal from 'sweetalert2';
import { toast } from "react-toastify";
import { Button } from '../components/ui/button';
import { getPasswordError } from '../utils/validations';

function ChangePassword() {
  const [showpassword, setShowpassword] = useState(true)
  const [hidepassword, setHidepassword] = useState(false)
  const [showpassword1, setShowpassword1] = useState(true)
  const [hidepassword1, setHidepassword1] = useState(false)
  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  })
  const ShowPass = () => {
    setShowpassword(false)
    setHidepassword(true)
  }
  const HidePass = () => {
    setHidepassword(true)
    setShowpassword(true)
  }
  const ShowPass1 = () => {
    setShowpassword1(false)
    setHidepassword1(true)
  }
  const HidePass1 = () => {
    setHidepassword1(true)
    setShowpassword1(true)
  }
  const handleChange = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    setPassword({
      ...password,
      [name]: value
    })
  }
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const passwordError = getPasswordError(password.newPassword);
    if (passwordError) {
      toast.error(passwordError);
      return;
    }
    if (password.newPassword === password.oldPassword) {
      toast.error("New password must be different from old password");
      return;
    }
    let data = {
      old_password: password.oldPassword,
      new_password: password.newPassword
    }
    try {
      let apiRes = await henceforthApi.Auth.changePassword(data)
        .then((res: any) => {
          console.log(res, "response");
          Swal.fire({
            title: "Password change SuccessFully",
            text: res.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
          window.history.back();
        }).catch((err: any) => {
          Swal.fire({
            title: err.response.body.error_description,
            text: err.response.body.error_description,
            icon: "error",
            confirmButtonText: "Cancel",
          });
        });
      setPassword({
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      })
    }
    catch { }
  }
  return (
    <div>
      <div className='row '>
        <form onSubmit={handleSubmit}>
          <div className='col-12 input-password'>
            <input className='form-control' type={showpassword ? "password" : "text"} onChange={handleChange} name="oldPassword" value={password.oldPassword} required placeholder='Enter old password' />
            {
              showpassword ? <i className="far fa-eye eye-icon" onClick={ShowPass}  ></i> : <i className="fas fa-eye-slash eye-icon" onClick={HidePass}  ></i>
            }
          </div>
          <div className='col-12 mt-3 input-password'>
            <input className='form-control' onChange={handleChange} type={showpassword1 ? "password" : "text"} name="newPassword" required value={password.newPassword} placeholder='Enter new password' maxLength={16} />
            {
              showpassword1 ? <i className="far fa-eye eye-icon" onClick={ShowPass1}  ></i> : <i className="fas fa-eye-slash eye-icon" onClick={HidePass1}  ></i>
            }
          </div>
          <small className='text-muted'>8-16 characters with uppercase, lowercase, number and special character. No sequences (1234) or repeats (aaa).</small>
          {/* <div className='col-12 mt-3'>
            <input className='form-control' onChange={handleChange} name="confirmedPassword" value={password.confirmPassword} placeholder='Enter confirmed password' />
        </div> */}
          <div className="flex items-center gap-2 mt-4">
            <Button
              type="button"
              variant="outline"
              onClick={() => { window.history.back(); }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
            >
              Change Password
            </Button>
          </div>

        </form>
      </div>
    </div>
  )
}

export default ChangePassword
